var exports = {
  "a": "Box__HBX6av",
};

module.exports = exports;
